import React from 'react';
import { Navigate } from 'react-router-dom';

import { AppRoutePath } from '../AppRoutePath';

export const RedirectToRequestLink = () => <Navigate to={AppRoutePath.AuthWildcard} replace />;
